module.exports = __webpack_public_path__ + "media/packs/images/land-b11dfea4a4858e1554ec4f7590f107ef.svg";